const calcLevel = (isPro, seller) => {
    const { level } = seller;

    return !isPro ? level : undefined;
};

export const baseTransformer = (props) => {
    const { seller, isPro } = props;

    const level = calcLevel(isPro, seller);

    return {
        ...props,
        seller: {
            ...seller,
            level,
        },
    };
};
